// mediaUploads.js — Handles all Firebase file upload/delete logic

import deleteFile from '../deleteFile';
import fileUpload from '../fileUpload';

/**
 * Uploads wallpaper and thumbnail images.
 * On edit: merges kept old images with newly uploaded ones.
 * On create: uploads everything fresh.
 */
export const uploadImages = async (imgData, type, isEdit) => {
    const uploadAll = (files, folder) => Promise.all(files.map((file) => fileUpload(file, type, 'create', folder)));

    let images, cardImages;

    if (isEdit) {
        const newWall = imgData?.newWallImg?.length ? await uploadAll(imgData.newWallImg, 'wallImg') : [];
        const newThumb = imgData?.newThumbImg?.length ? await uploadAll(imgData.newThumbImg, 'thumbImg') : [];
        images = [...(imgData.oldWallImg || []), ...newWall];
        cardImages = [...(imgData.oldThumbImg || []), ...newThumb];
    } else {
        images = await uploadAll(imgData.newWallImg, 'wallImg');
        cardImages = await uploadAll(imgData.newThumbImg, 'thumbImg');
    }

    return { images, cardImages };
};

/**
 * Handles video upload, replacement, or removal.
 *
 * Cases:
 *  - Edit + new File  → delete old (if any), upload new
 *  - Edit + cleared   → delete old
 *  - Edit + unchanged → keep existing URL
 *  - Create + File    → upload
 *  - Create + none    → empty array
 */
export const uploadVideo = async (videoFile, packData, type, isEdit) => {
    const existingVideo = packData?.videos?.[0];

    if (isEdit) {
        if (videoFile instanceof File) {
            if (existingVideo) await deleteFile(existingVideo);
            const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
            return [videoURL];
        }

        if (!videoFile && existingVideo) {
            await deleteFile(existingVideo);
            return [];
        }

        return packData.videos || [];
    }

    // Create flow
    if (videoFile instanceof File) {
        const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
        return [videoURL];
    }

    return [];
};
